export default `       <div>
<p style="margin:0pt; orphans:0; text-align:justify; widows:0"><span
        style=" font-size:10.5pt; font-weight:bold">【投保前提条件</span><span
        style=" font-size:10.5pt; font-weight:bold">告知</span><span
        style=" font-size:10.5pt; font-weight:bold">】</span></p>
<p style="margin:0pt; orphans:0; text-align:justify; widows:0"><span
        style=" font-size:10.5pt">投保本保险前，投保人应如实告知本保险以下投保前提条件有关的情况，确认符合下列所有投保前提条件方可进行投保，若保险合同订立后发现不符合下列任何投保前提条件的，则视为投保人故意未依法履行如实告知义务。</span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; widows:0"><span
        style=" font-size:10.5pt; font-weight:bold">&#xa0;</span></p>
<p style="margin:0pt; orphans:0; text-align:justify; widows:0"><span
        style=" font-size:10.5pt; font-weight:bold">投保前提条件：</span></p>
<p style="margin:0pt; text-indent:21pt"><span style=" font-size:10.5pt">1.</span><span
        style=" font-size:10.5pt"> 投保人不属于以下保险公司不接受投保的行业之一：</span><span
        style=" font-size:10.5pt">渔业、</span><span
        style=" font-size:10.5pt">森林砍伐业</span><span
        style=" font-size:10.5pt">、</span><span
        style=" font-size:10.5pt">矿业采石业</span><span
        style=" font-size:10.5pt">、航运业</span><span
        style=" font-size:10.5pt">以及涉及隧道作业、地下作业、山洞作业、水上作业、易燃易爆物品生产和运输、武器弹药研究和开发、驯兽及凶猛动物养殖的职业活动的企业</span><span
        style=" font-size:10.5pt">。</span></p>
<p style="margin:0pt; text-indent:21pt"><span style=" font-size:10.5pt">2.</span><span
        style=" font-size:10.5pt"> 任何提出投保申请的人员或在保险期间内提出参保申请的人员均符合本保险</span><span
        style=" font-size:10.5pt">约定的团体成员</span><span
        style=" font-size:10.5pt">资格</span><span
        style=" font-size:10.5pt">。</span><span
        style=" font-size:10.5pt">本保险</span><span
        style=" font-size:10.5pt">约定的团体成员</span><span
        style=" font-size:10.5pt">资格须同时满足以下要求</span><span
        style=" font-size:10.5pt">：</span></p>
<p style="margin:0pt; orphans:0; text-align:justify; widows:0"><span
        style=" font-size:10.5pt">（1）属于投保人</span><span
        style=" font-size:10.5pt">所申报的符合</span><span
        style=" font-size:10.5pt">所有</span><span
        style=" font-size:10.5pt">投保条件的</span><span
        style=" font-size:10.5pt">其</span><span
        style=" font-size:10.5pt">于中国大陆境内直接雇佣的</span><span
        style=" font-size:10.5pt">属于</span><span
        style=" font-size:10.5pt">本保险</span><span
        style=" font-size:10.5pt">接受投保</span><span
        style=" font-size:10.5pt">职业类别</span><span
        style=" font-size:10.5pt">的在岗</span><span
        style=" font-size:10.5pt">全职雇员</span><span
        style=" font-size:10.5pt">，</span><span
        style=" font-size:10.5pt; font-weight:bold">但不包括任何国家或国际组织认定的恐怖分子或恐怖组织成员，或非法从事毒品、核武器、生物或化学武器交易人员。</span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; widows:0"><span
        style=" font-size:10.5pt">本保险所称的“直接雇佣”是指投保人与其所申报的人员直接订立书面劳动合同或其他书面形式的用工合同，该人员直接为投保人工作，并由投保人直接给付工资或报酬的情形，包括投保人短期雇用的情形。</span><span
        style=" font-size:10.5pt">约定的团体成员投保年龄限制</span><span
        style=" font-size:10.5pt">：18-65周岁，连续投保可至70周岁。</span></p>
<p style="margin:0pt; orphans:0; text-align:justify; widows:0"><span
        style=" font-size:10.5pt">（2）属于中国大陆境内（不含香港、澳门、台湾）常住，且身体健康、能正常工作和正常生活的被保险人，中国大陆境内常住是指申报投保或参保前一年内在中国大陆境内的居住时间累计达到或超过183天。</span>
</p>
<p style="margin:0pt; text-indent:21pt"><span style=" font-size:10.5pt">3.</span><span
        style=" font-size:10.5pt">
        投保人未曾被任何保险公司拒绝投保申请，未曾被任何保险公司拒绝保险合同续保，未曾被任何保险公司解除保险合同，且未曾被任何保险公司要求加费或附加特别约定方可承保</span><span
        style=" font-size:10.5pt">。</span></p>
<p style="margin:0pt; text-indent:21pt"><span style=" font-size:10.5pt">4.</span><span
        style=" font-size:10.5pt"> 投保人（包括子公司和分支机构）在下列这些国家中不存在风险</span><span
        style=" font-size:10.5pt">*</span><span
        style=" font-size:10.5pt">：古巴、伊朗、叙利亚、朝鲜、乌克兰克里米亚地区</span></p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"><span
        style=" font-size:10.5pt">“</span><span
        style=" font-size:10.5pt">风险</span><span
        style=" font-size:10.5pt">”</span><span
        style=" font-size:10.5pt">是指下列任一情形：</span></p>
<p style="margin:0pt; text-indent:21pt"><span
        style=" font-size:10.5pt">i.</span><span
        style="font:7.0pt 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span><span
        style=" font-size:10.5pt">投保人的注册地、住所地或运营地位于上述任何国家。</span></p>
<p style="margin:0pt; text-indent:21pt"><span
        style=" font-size:10.5pt">ii.</span><span
        style="font:7.0pt 'Times New Roman'">&#xa0;&#xa0;&#xa0; </span><span
        style=" font-size:10.5pt">投保人所从事的业务活动涉及古巴、乌克兰克里米亚地区、伊朗或叙利亚（例如：服务、货运、销售、供应渠道、投保财产）。</span>
</p>
<p style="margin:0pt; text-indent:21pt"><span
        style=" font-size:10.5pt">iii.</span><span
        style="font:7.0pt 'Times New Roman'">&#xa0; </span><span
        style=" font-size:10.5pt">投保人的董事会成员或高级管理人员住所地在古巴、乌克兰克里米亚地区、伊朗或叙利亚，或者投保人的大股东（包括个人或者实体）的注册地、住所地或居住地在古巴、乌克兰克里米亚地区、伊朗或叙利亚。</span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"><span
        style=" font-size:10.5pt">&#xa0;</span></p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0"><span
        style=" font-size:10.5pt">对于上述任何一项投保前提条件，如投保人未进行确认的，则保险公司不接受投保人投保本保险的申请；对于上述第</span><span
        style=" font-size:10.5pt">2</span><span
        style=" font-size:10.5pt">项投保前提条件，如本保险投保时投保人确认符合该项投保前提条件，但任何投保人员在保险合同订立后或在保险合同有效期内发现不符合的，则</span><span
        style=" font-size:10.5pt; font-weight:bold">保险公司有权依据合同约定取消该人员的被保资格，并对于取消其被保资格前所发生的保险事故不承担任何保险责任。</span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; widows:0"><span
        style=" font-size:10.5pt">&#xa0;</span></p>
</div>`